<template>
    <transition name="fade">
        <div id="del_popup" v-if="isVisible" @click="close">
            <div class="del_popup" @click.stop>
                <div class="del_popup1">
                    <div class="del_popup1_1">
                        <img :src="delPrompt[delIndex].icon" alt="">
                        提醒
                    </div>
                    <img class="del_popup1_2" src="../assets/image/icon_close.png" alt="" @click="close">
                </div>
                <div class="del_popup2">{{ delPrompt[delIndex].text }}</div>
                <div class="del_popup3">
                    <div class="del_popup3_1" :style="{ background: delPrompt[delIndex].color }"
                        @click="confirmSelect">
                        确认
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import api from '@/api/api';
import data from '@/assets/data';
import { EventBus } from '@/utils/eventBus';

export default {
    data() {
        return {
            delPrompt: data.delPrompt, // 删除文本提示
            delIndex: null, //显示内容下标
            isVisible: false
        };
    },
    mounted() {
        EventBus.$on('openPrompt', (i) => {
            this.open(i)
        })
    },
    beforeDestroy() {
        EventBus.$off('openPrompt');
    },
    methods: {
        open(i) {
            this.delIndex = i;
            this.isVisible = true;
        },
        close() {
            this.isVisible = false;
        },
        confirmSelect() {
            // 处理确认逻辑
            if (this.delIndex == 0 || this.delIndex == 3 || this.delIndex == 4 || this.delIndex == 5) {
                this.isVisible = false;
                this.$emit('confirm') 
            } else if (this.delIndex == 2) {
                this.logout()
            }else if (this.delIndex == 1 || this.delIndex == 6 || this.delIndex == 7) {
                this.isVisible = false;
            }
        },
        logout() {
            api.logout().then((res) => {
                if (res.code == 200) {
                    this.$message({
                        message: "退出成功！",
                        type: "success",
                    });
                    // localStorage.removeItem("token_key");
                    localStorage.clear()
                    sessionStorage.clear();
                    window.location.reload()
                    window.location.href = '/';
                    // this.$router.push({ path: '/home' });
                }
            })
        }
    }
};
</script>

<style>
#del_popup {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.del_popup {
    background-color: #FFF;
    padding: 15px 20px;
    border-radius: 10px;
}

.del_popup1 {
    width: 260px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.del_popup1_1 {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 15px;
    color: #18191A;
}

.del_popup1_1 img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

.del_popup1_2 {
    width: 20px;
    height: 20px;
}

.del_popup2 {
    width: 260px;
    font-size: 16px;
    color: #000000;
    margin: 15px 0;
}

.del_popup3 {
    width: 260px;
    display: flex;
    justify-content: end;
}

.del_popup3_1 {
    width: 83px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    color: #FFFFFF;
    /* background: var(--tech-primary); */
    border-radius: 4px;
    cursor: pointer;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>